import { gql } from '@apollo/client'

export default gql(`
  query getConfig ($id: ID!){
    getConfig(id: $id){
        id
        value
        key
    }
  }
`)
